import React, { useContext, useState } from 'react';
import { Typography, Modal } from 'antd';
import Tilt from 'react-tilt';
import SearchContext from '../../../../context';
import video_icon from '../../../../assets/bg/video.svg';
import link_icon from '../../../../assets/bg/link.svg';
import info_icon from '../../../../assets/bg/info.svg';
import { Wrapper } from '../../../../theme/MainTheme';
import { useTheme } from "../../../../ThemeContext.js";
import close_light from '../../../../assets/bg/close_modal.svg';
import { Row } from 'react-flexbox-grid';

const Card = (props) => {

    const contextService = useContext(SearchContext);

    const themeState = useTheme(); 

    const { Title } = Typography;

    const tilitOptions = {
        reverse:        false,  // reverse the tilt direction
        max:            20,     // max tilt rotation (degrees)
        perspective:    1000,   // Transform perspective, the lower the more extreme the tilt gets.
        scale:          1.05,      // 2 = 200%, 1.5 = 150%, etc..
        speed:          300,    // Speed of the enter/exit transition
        transition:     true,   // Set a transition on enter/exit.
        axis:           null,   // What axis should be disabled. Can be X or Y.
        reset:          true,   // If the tilt effect has to be reset on exit.
        easing:         "cubic-bezier(.03,.98,.52,.99)",    // Easing on enter/exit.
    }

    const [isModal, setModal] = useState(false);
    const [detalle, setData] = useState();

    const renderPadding = () => {
        if(props.item.hasVideo === false && props.item.url === ''){
            return undefined
        }
        else if(props.item.hasVideo !== false && props.item.url === ''){
            return '.75em'
        }
        else if(props.item.hasVideo === false){
            return undefined
        }
        else if(props.item.url === ''){
            return undefined
        }
        else{
            return '.75em'
        }
    }

    return(
        <div key={props.i} className="no-padding" style={{ width: `calc(100% - 1em)`, height: props.item.height, marginBottom: contextService.width <= 767 ? '1em' : '1em' }} >
            <Tilt options={tilitOptions} className="tilt">
                <div className="card-project" style={{ backgroundImage: props.item.gradient, padding: '1.25em', width: '100%', height: '100%', borderRadius: 'inherit', display: 'flex', alignItems: 'flex-start', justifyContent: props.item.position === 'top' ? 'flex-start' : 'flex-end', flexDirection: 'column' }} >
                    <Title className="montserrat white-title-color" style={{ fontSize: '.65rem', textTransform: 'uppercase' }}>
                        {props.item.tech}
                    </Title>
                    <Title className="white-title-color" style={{ paddingTop: '.25em', fontSize: '1.75rem' }}>
                        {props.item.titulo}
                    </Title>
                    <span className="montserrat white-title-color" style={{ paddingTop: '.25em', fontSize: '1.15rem' }}>
                        {props.item.slug}
                    </span>
                    <div style={{ width: '100%', marginTop: '.45em', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'row' }} >
                        {
                            props.item.hasVideo !== false ?
                            <div>
                                <img src={video_icon} alt={video_icon} style={{ width: 30, cursor: 'pointer' }} />
                            </div> : undefined
                        }
                        {
                            props.item.url === '' ? undefined : 
                            <a href={props.item.url} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                                <div style={{ margin: props.item.hasVideo === false ? '0 .75em 0 0' : '0 0 0 0.75em' }} >
                                    <img src={link_icon} alt={link_icon} style={{ width: 40, cursor: 'pointer' }} />
                                </div>
                            </a>
                        }
                        <div onClick={() => {setModal(!isModal); setData(props.item)}} className="montserrat white-title-color" style={{ paddingLeft: renderPadding(), cursor: 'pointer' }}>
                            <img src={info_icon} alt={info_icon} style={{ width: 30, cursor: 'pointer' }} />
                        </div>
                    </div>
                </div>
            </Tilt>
            <Modal centered footer={null} closable={false} bodyStyle={{ backgroundColor: themeState.dark === true ? '#121212' : '#FFFFFF' }} style={{ top: '2em' }} title={null} maskStyle={{ backgroundColor: 'rgba(0,0,0,.4)', backdropFilter: 'backdrop-filter: saturate(180%) blur(20px)' }} visible={isModal} onCancel={() => setModal(!isModal)} onOk={() => setModal(!isModal)} okType="primary">
                {
                    detalle === undefined ? undefined : 
                    <Wrapper>
                        <div style={{ padding: '1em 0em', width: '100%', height: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'row' }} >
                            <div onClick={() => setModal(!isModal)} className="main-cta main-shadow" style={{ cursor: 'pointer', width: 40, height: 40, borderRadius: '5em', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                                <img src={close_light} alt={close_light}  style={{ width: 20 }} />
                            </div>
                            <Title className="main-title-color" style={{ paddingLeft: '.45em', fontSize: '1.95rem' }} >
                                {detalle.titulo}
                            </Title>
                        </div>
                        <div style={{ padding: '1em 0em', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }} >
                            <span className="secondary-title-color" style={{ fontSize: '1.15rem' }} >
                                {detalle.descripcion.titulo}
                            </span>
                        </div>
                        <Row style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'row', flexFlow: 'wrap' }} >
                            <ul>
                                {
                                    detalle.descripcion.bullets.map((item, i) => {
                                        return(
                                            <li key={i} className="secondary-title-color" >
                                                <span className="secondary-title-color" style={{ fontSize: '1.15rem' }} >{item}</span>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </Row>
                    </Wrapper>
                }
            </Modal>
        </div>
    )
}

export default Card